import {
  GET_MNO_BUNDLE_REPORT,
  GET_MNO_COST_ANALYTICS_REPORT,
  GET_MNO_BUNDLE_GRAPH_REPORT,
  GET_TELECOM_SUMMARY_REPORT,
  GET_TELECOM_BUNDLE_DATA_REPORT,
} from 'redux/admin-constants';

const initialState = {
  mnoBundleReport: [],
  mnoCostAnalyticsReport: null,
  mnoBundleGraphReport: [],
  mnoTelecomSummaryReport: null,
  mnoTelecomBundleReport: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_MNO_BUNDLE_REPORT: {
      return {
        ...state,
        mnoBundleReport: payload,
      };
    }
    case GET_MNO_COST_ANALYTICS_REPORT: {
      return {
        ...state,
        mnoCostAnalyticsReport: payload,
      };
    }
    case GET_MNO_BUNDLE_GRAPH_REPORT: {
      return {
        ...state,
        mnoBundleGraphReport: payload,
      };
    }
    case GET_TELECOM_SUMMARY_REPORT: {
      return {
        ...state,
        mnoTelecomSummaryReport: payload,
      };
    }
    case GET_TELECOM_BUNDLE_DATA_REPORT: {
      return {
        ...state,
        mnoTelecomBundleReport: payload,
      };
    }
    default:
      return state;
  }
};

export default reducer;
